<template>
	<v-container grid-list-xl v-if="show">
		<v-layout
			row
			justify-center
		>
			<v-flex
				xs12
				md8
				pa-0
			>
				<NewItem
					v-if="canEdit"
					ref="newItem"
					button-title="New Override"
				>
					<template slot="form">
						<OverridesForm
							@close="$refs.newItem.close()"
						/>
					</template>
				</NewItem>
			</v-flex>
		</v-layout>

		<OverridesIterator
			:items="overrides"
			@update="updateField"
			@delete="deleteField"
		/>

		<v-dialog
			v-model="showEditDialog"
			max-width="800"
		>
			<v-card>
				<v-container grid-list-xl>
					<OverridesForm
						:edit-override="editOverride"
						@close="showEditDialog = false"
					/>
				</v-container>
			</v-card>
		</v-dialog>

		<Confirm ref="confirm" />
	</v-container>
</template>

<script>
import OverridesForm from '@/components/Project/Overrides/OverridesForm';
import OverridesIterator from '@/components/Project/Overrides/OverridesIterator';
import NewItem from '@/components/NewItem';
import Confirm from '@/components/Confirm';
import Validation from '@/mixins/Validation';
import { Keyword, KeywordList, KeywordListDefault } from '@/models/Keyword';

export default {
	components: {
		OverridesForm,
		OverridesIterator,
		NewItem,
		Confirm,
	},
	mixins: [Validation],
	data() {
		return {
			show: false,
			showEditDialog: false,
			valid: { new: true, add: true, rename: true },
			editOverride: null,
		};
	},
	created() {
		this.show = this.$store.get('superUser'); //this.project.userCan('view_custom_data');
		if (!this.show) {
			this.$router.replace({ name: 'NotFound' });
		}
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		overrides() {
			return this.$store.state.projects.currentProject.overrides;
		},
		canEdit() {
			//return this.project.userCan('manage_custom_data') && !this.project.isArchived;
			return !this.project.isArchived;
		},
	},
	methods: {
		updateField(override) {
			this.editOverride = override;
			this.showEditDialog = true;
		},
		deleteField(override) {
			const name = override.id;

			this.$refs.confirm.createConfirm(`This will delete override "${name}".`, 'error').then((answer) => {
				if (!answer) {
					return;
				}
				override.delete().then(() => {
					this.overrides.forEach((f) => {
						if (!f.id) {
							const deleteIndex = this.overrides.indexOf(f);
							this.overrides.splice(deleteIndex, 1);
						}
					});
					this.$notify('success', `Override "${name}" has been deleted.`);
				}).catch(() => {
					this.$notify('error', `Failed to delete override "${name}".`);
				});
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.small-btn {
	margin-top: 0;
	margin-right: -10px;
	margin-bottom: 0;
}
.absolute--right {
	position: absolute;
	top: 0;
	right: 0;
}
</style>
